export default "__VITE_ASSET__CNL_dxWo__"